/**
 * Vite DEV detection + query flags for audio tooling.
 * Production builds never enable synth tones.
 */

export function isViteDev(): boolean {
  try {
    // Vite replaces import.meta.env.DEV at build time (false in production).
    return Boolean(import.meta.env?.DEV);
  } catch {
    return false;
  }
}

/** `?audioSynth=1` — force procedural tones even when files exist (DEV only). */
export function forceAudioSynth(
  search: string = typeof location !== "undefined" ? location.search : "",
): boolean {
  if (!isViteDev()) return false;
  try {
    const q = new URLSearchParams(
      search.startsWith("?") ? search : search ? `?${search}` : "",
    );
    const v = q.get("audioSynth");
    return v === "1" || v === "true" || v === "on";
  } catch {
    return false;
  }
}

/**
 * Whether missing assets may synthesize tones.
 * - Production: never
 * - DEV: yes (default), so engineering is unblocked without binary packs
 */
export function allowDevSynthFallback(): boolean {
  return isViteDev();
}
